import React from 'react';
import { H2, P, OL, LI, Callout, FeatureLink } from './_shared';

export default {
  slug: 'ai-email',
  title: 'Drafting emails with AI',
  category: 'ai',
  summary: 'The "✨ Draft email with AI" button on every client page — six intent presets, custom notes, and editable drafts before send.',
  searchTerms: ['ai', 'email', 'draft', 'claude', 'compose'],
  related: ['health-score', 'broker-dashboard'],
  Body: () => (
    <>
      <P>
        On every client and folder page there's a <strong>✨ Draft email
        with AI</strong> button. Click it and you get a short, editable
        draft tailored to that client's history and the intent you pick.
      </P>

      <H2>How to use it</H2>
      <OL>
        <LI>Pick an <strong>intent</strong> — Follow-up, Schedule a showing, Send a doc reminder, Check in after closing, Re-engage cold lead, or Custom.</LI>
        <LI>Optionally add a <strong>note</strong> to steer tone or content ("warm but not pushy," "remind them inspection is Tuesday").</LI>
        <LI>Click <strong>Generate</strong>. The draft appears in seconds.</LI>
        <LI>Edit freely. The AI is a starting point, not a send-without-reading button.</LI>
        <LI>Hit <strong>Send</strong> or <strong>Save as draft</strong>.</LI>
      </OL>

      <H2>What it knows about the client</H2>
      <P>
        The model gets: the client's name, recent activity (last 30 days),
        the active folder's status, the deal's property + budget, and any
        notes you've left. Personally identifying details beyond that don't
        leave your tenant.
      </P>

      <Callout kind="info">
        We use Anthropic Claude Haiku for these drafts. Your prompt and the
        client context go to Anthropic but are not used for training (per
        their commercial terms). Drafts are cached for 5 minutes so you can
        regenerate without re-incurring cost.
      </Callout>

      <H2>Cost & limits</H2>
      <P>
        AI email drafts are unmetered on Pro and above. Free tier gets 20
        drafts per month. You can see your usage in{' '}
        <FeatureLink to="/billing">Billing → Usage</FeatureLink>.
      </P>
    </>
  ),
};
